module.exports = __webpack_public_path__ + "static/media/dec16gig.cb6479d5.jpeg";